module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/mock/mockData.json
// module id = 1404
// module chunks = 2